// 请求接口的baseurl，通过cross-env传入，供easy-mock使用
const baseURL = process.env.VUE_APP_BASEURL || 'function';
const defaultConfig = {
  // picBase: 'function/pics-service', // 图片根路径
  baseURL, // 接口地址base
  useVerifyCode: false, // 登录是否始终使用验证码
  logo: 'aibee', // 页面logo src/assets/x.png
  title: 'AiBEE 部署管理平台', // 系统名称
};

export default defaultConfig;
